import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3zqche274q: FaireBrandEntity = {
  token: "b_3zqche274q",
  type: "brand",
  name: "Ready To",
  avatarUrl:
    "https://cdn.faire.com/fastly/4b33d525cfbf017399825084055e7f2c2cdc90137ed80a17d5a9d7a2f05a18dd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5456538c94912730eb0f7995e56b0353931ef2f34ef35a540e53bf7a8d4251f9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4b33d525cfbf017399825084055e7f2c2cdc90137ed80a17d5a9d7a2f05a18dd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5456538c94912730eb0f7995e56b0353931ef2f34ef35a540e53bf7a8d4251f9.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 0,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "My personal mental health journey led me to explore natural remedies like vitamins, minerals and herbs. Yet, I often find myself relying on blind faith - questioning their origin, purity and quality. Not finding a brand I trusted, I founded Ready To.\n\nWith us, you'll have full knowledge of what goes into your body and how it's sourced. Traceability is our North Star, we’re honored to share the details of our manufacturing from start to finish with you. Our partners share our unwavering dedication to transparency and sustainability throughout the supply chain.\n\nJosh Yong, Founder.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:20.141Z",
    importedBy: "entity-db-cli",
  },
};
